module.exports = __webpack_public_path__ + "img/immunizations.c91b3974.svg";